import React, { useContext, useRef } from "react";
import { useState } from "react";
import { useEffect } from "react";
import { decryptText, pbdkf2 } from "../../Utils/OstreonEncryption";
import { useAuth } from "../../Context/AuthContext";
import styles from "./styles/LoginRecoveryKey.module.css";
import { useNavigate } from "react-router-dom";
import config from "../../config";
import { serverLogout } from "../../Utils/serverLogout";
import Info from "../User/Info/info";
import { isValidEmail } from "../../Utils/isValidEmail";
import { LanguageContext } from "../../Context/changeLanguageProvider";
import { formattingRedirectionUrl } from "../../Utils/redirectingUrl";

const base_url = config.base_url;
export function LoginRecoveryKey() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
    });
  };

  useEffect(() => {
    scrollToTop();
  }, []);
  const [disableLogin, setDisabledLogin] = useState(false);
  const websiteCurrentLang = useContext(LanguageContext).language;
  const [content, setContent] = useState(
    websiteCurrentLang.content.Login.LoginRecoveryKey
  );
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  useEffect(() => {
    setContent(websiteCurrentLang.content.Login.LoginRecoveryKey);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);
  const [username, setUsername] = useState();
  const [recovery_key, setKey] = useState({
    seed1: "",
    seed2: "",
    seed3: "",
    seed4: "",
    seed5: "",
    seed6: "",
    seed7: "",
    seed8: "",
  });
  const [loginError, setLoginError] = useState(null);
  const [error, setError] = useState({
    email: "",
    key: "",
  });
  const auth = useAuth();
  const navigate = useNavigate();
  const inputRefs = useRef([]);
  const changeKey = (seed, value_, index) => {
    const value = value_.toUpperCase();
    const regex = /^([A-Za-z0-9]{4}-){7}[A-Za-z0-9]{4}$/;
    if (regex.test(value)) {
      const parts = value.split("-");
      let joined_key = {
        seed1: "",
        seed2: "",
        seed3: "",
        seed4: "",
        seed5: "",
        seed6: "",
        seed7: "",
        seed8: "",
      };
      parts.map((e, index) => {
        joined_key[`seed${index + 1}`] = e;
        return null;
      });
      setKey(joined_key);
    } else {
      console.log("String does not have correct format");
      if (value.length <= 4) setKey({ ...recovery_key, [seed]: value });
      if (value.length === 4) inputRefs.current[index + 1].focus();
      if (value.length === 0) inputRefs.current[index - 1].focus();
    }
  };
  useEffect(() => {
    if (auth.otp) {
      serverLogout();
      auth.logout();
    }
  }, [auth]);
  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://www.google.com/recaptcha/api.js?render=6Ldi00MoAAAAAOhEarj3D8oPKndxNMGHPNVPeciu";
    document.body.appendChild(script);
  }, []);
  const showError = (error) => {
    setLoginError(error);
    setTimeout(() => {
      setLoginError(null);
    }, 3000);
  };
  const handleLogin = async (token) => {
    let recovery_key_joined = recovery_key[Object.keys(recovery_key)[0]];
    let keys = Object.keys(recovery_key);
    keys.shift();
    keys.forEach((element) => {
      recovery_key_joined = recovery_key_joined + "-" + recovery_key[element];
    });
    const [pbdkf2hash] = await pbdkf2(
      recovery_key_joined,
      "OSTREON",
      100000,
      32 * 8
    );
    fetch(base_url + "login/recoverykey", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      body: `username=${username}&recovery_key=${pbdkf2hash}&token=${token}`,
      credentials: "include",
    })
      .then((res) => {
        if (res.status === 429) showError(dublicatedcontent.dublicatedText51);
        else if (res.status === 403)
          showError(content.PasswrodRecoveryGeneralError1);
        else if (res.status === 500)
          showError(content.PasswrodRecoveryGeneralError2);
        else if (res.status === 498)
          showError(dublicatedcontent.dublicatedText49);
        else if (res.status === 404)
          showError(content.PasswrodRecoveryAccountNotActivatedError);
        else return res.json();
      })
      .then(async (data) => {
        if (!data) return;
        if (data.error) showError(data.error);
        else {
          console.log(data);
          const encrypted_key = data.success.private_key;
          const decrypted_private_key = await decryptText(
            recovery_key_joined,
            encrypted_key
          );
          // const hash = SHA('sha256').update(decrypted_private_key).digest('hex')
          window.sessionStorage.setItem("ostreon_key", decrypted_private_key);
          // userData.setEmail(username)
          auth.login("OK");
          auth.setEmail(username);
          auth.setPWDChange("Recovery Key Access");
          if (data.success.OTP === "true") {
            auth.setOTP(true);
            navigate("/user/changepwd", { replace: true });
          }
        }
      })
      .catch((err) => {
        console.log(err);
        showError(content.PasswrodRecoveryGeneralError1);
      })
      .finally(() => {
        setDisabledLogin(false);
      });
  };
  const submitCaptcha = (e) => {
    e.preventDefault();
    window.grecaptcha.ready(() => {
      setDisabledLogin(true);
      window.grecaptcha
        .execute("6Ldi00MoAAAAAOhEarj3D8oPKndxNMGHPNVPeciu")
        .then((token) => {
          const hasEmptyValue = Object.keys(recovery_key).some(
            (key) => recovery_key[key] === ""
          );
          const newErrors = {};
          if (!username) {
            newErrors.email = content.PasswrodRecoveryEmailError;
          }
          if ((username && !isValidEmail(username)) || !username) {
            newErrors.email = dublicatedcontent.dublicatedText47;
          }
          if (hasEmptyValue) {
            newErrors.key = content.PasswrodRecoveryRecoveryCodeError;
          }
          if (Object.keys(newErrors).length > 0) {
            setError(newErrors);
            setDisabledLogin(false);
            setTimeout(() => {
              Object.keys(error).forEach((key) => {
                setError((prevError) => ({ ...prevError, [key]: null }));
              });
            }, 5000);
          } else {
            handleLogin(token);
          }
        })
        .catch((e) => {
          setDisabledLogin(false);
        });
    });
  };
  const handleEnter = (e) => {
    if (e.key === "Enter") {
      submitCaptcha(e);
    }
  };
  return (
    <div className={styles.main_div} onKeyDown={handleEnter}>
      <div
        className={styles.home_link}
        onClick={() => {
          window.location.href = formattingRedirectionUrl("");
        }}
      >
        {dublicatedcontent.dublicatedText41}
      </div>
      <div className={styles.title}>{content.PasswrodRecoveryTitle2}</div>
      <div className={styles.text}>
        {content.PasswrodRecoveryText1}{" "}
        <a
          className={styles.blue_link}
          href={dublicatedcontent?.intercom_recover_password}
          target="_blank"
        >
          {dublicatedcontent.dublicatedText68}
        </a>
      </div>
      <div className={styles.main}>
        <div className={styles.top}>
          <div className={styles.inputs}>
            <div
              className={`${styles.input_div} ${
                error?.email ? styles.field_error : ""
              } ${loginError ? styles.field_error : ""}`}
            >
              <div className={styles.input_text}>
                {dublicatedcontent.dublicatedText42}{" "}
                <Info message={dublicatedcontent.dublicatedText43} />
              </div>
              <input
                autoFocus
                className={styles.input}
                value={username}
                onChange={(e) => {
                  setUsername(e.target.value.toLowerCase());
                }}
                placeholder={dublicatedcontent.dublicatedText42}
              ></input>
              {error?.email ? (
                <div className={styles.login_error}>{error.email}</div>
              ) : null}
            </div>
          </div>
          <div
            className={`${styles.big_field} ${
              error?.key ? styles.field_error : ""
            }`}
          >
            <div className={styles.recovery_input_title}>
              {dublicatedcontent?.insert_your_recovery_code}{" "}
              <Info message={dublicatedcontent.dublicatedText44} />
            </div>
            <div
              className={`${styles.recovery_key_div} ${
                loginError ? styles.error_fields : ""
              }`}
            >
              {Object.keys(recovery_key).map((seed, index) => {
                if (index + 1 === Object.keys(recovery_key).length)
                  return (
                    <input
                      ref={(ref) => (inputRefs.current[index] = ref)}
                      onChange={(e) => {
                        changeKey(`${seed}`, e.target.value, index);
                      }}
                      value={recovery_key[seed]}
                      className={styles.recovery_key}
                    ></input>
                  );
                else
                  return (
                    <>
                      <input
                        ref={(ref) => (inputRefs.current[index] = ref)}
                        onChange={(e) => {
                          changeKey(`${seed}`, e.target.value, index);
                        }}
                        value={recovery_key[seed]}
                        className={styles.recovery_key}
                      ></input>
                    </>
                  );
              })}
            </div>
            {error?.key ? (
              <div className={styles.login_error}>{error.key}</div>
            ) : null}
          </div>
          <div className={styles.footer}>
            {loginError ? (
              <div className={styles.login_error}>{loginError}</div>
            ) : null}
            <button
              disabled={disableLogin}
              onClick={(e) => submitCaptcha(e)}
              className={styles.login_button}
            >
              {content.PasswrodRecoveryButton1}
            </button>
            <button
              onClick={() => navigate("/login", { replace: false })}
              className={styles.back_to_login}
            >
              {content.PasswrodRecoveryButton2}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
